/** @jsx isolateComponent */

import { Button, ButtonGroup } from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';

type ConfirmSectionProps = {
  /** Text to display on cancel button */
  cancelText: string;
  /** Text to display on confirm button */
  confirmText: string;
  /** Is confirm button disabled */
  isConfirmDisabled?: boolean;
  /** Function to run when user clicks cancel button */
  onCancel: Function;
  /** Function to run when user clicks confirm button */
  onConfirm: Function;
};

export const ConfirmSection = ({
  cancelText,
  confirmText,
  isConfirmDisabled,
  onConfirm,
  onCancel,
}: ConfirmSectionProps) => {
  return (
    <ButtonGroup
      direction="row"
      isFlex={true}
      propsQueries={{
        phoneOnly: {
          direction: 'column',
          isReversed: true,
        },
      }}
    >
      <Button onClick={onCancel}>{cancelText}</Button>

      <Button
        color="primary"
        isDisabled={isConfirmDisabled}
        onClick={onConfirm}
      >
        {confirmText}
      </Button>
    </ButtonGroup>
  );
};
